export default {
  aa: 'aa',
};
